<template>
  <div id="myDateShow">
    <div class="title">{{admin.id?"修改":"新增"}} 管理员信息</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">管理员名称</div>
        <div class="value">
          <el-input class="w500" v-model="admin.username" maxlength="10" show-word-limit placeholder="请填写管理员名称"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">管理员密码</div>
        <div class="value">
          <el-input class="w500" v-model="admin.password" type="password" placeholder="请输入管理员密码"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">确认密码</div>
        <div class="value">
          <el-input class="w500" v-model="password" type="password" placeholder="请输入管理员密码"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">管理员角色</div>
        <div class="value">
          <el-select style="width: 250px;" v-model="admin.roleId" placeholder="请选择管理员角色">
            <el-option
                    v-for="item in options"
                    :key="item.label"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
          <el-button style="margin-left: 20px" type="primary" size="medium" @click="toRoleData">新增角色</el-button>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getAdminById, getRoleAll, newVue, setRole, updateAdmin} from "../../network/admin";
  import {errorMsg, utilVue} from "../../utils/util";


  export default {
    name: "AdminInsert",
    data(){
      return{
        admin: {
          username:'',
          roleId:"",
        },
        adminId: '',
        options: [

        ],
        password:''
      }
    },
    created() {
      newVue.obj = this;
      utilVue.obj = this;
      this.common.HeaderLocationTwo.href = "/admin/list";
      this.common.HeaderLocationTwo.name = "平台管理员管理";
      this.common.HeaderLocationThree.name = "新增or修改管理员"
      if (this.$route.params.id!=null){
        this.adminId = this.$route.params.id;

        getAdminById(this.adminId).then(res => {
          this.admin = res.data;
          this.admin.roleId = res.data.roleList[0].id
        })
      }
      getRoleAll().then(res => {
        let roles = res.data;
        for(let role of roles){
          let option = {};
          option.value = role.id;
          option.label = role.roleName;
          this.options.push(option)
        }
      })
    },
    methods: {
      backClick(){
        this.$router.push("../list");
      },
      toRoleData(){
        setRole(null)
        this.$router.push("/role/data");
      },
      submit(){
        if (this.admin.username==null||this.admin.username==""){
          errorMsg("请先填写管理员名称")
          return;
        }
        if (this.admin.password==null||this.password!=this.admin.password){
          errorMsg("请先确认密码无误")
          return;
        }
        //if (this.admin.roleList[0]==null){
        if (this.admin.roleId==null){
          errorMsg("请选择角色")
          return;
        }
        updateAdmin(this.admin).then(res => {
          console.log(res);
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
